import VideoIcon from './component'

export default VideoIcon
